<template>
  <div class="row">
    <div class="col-12">
      <validation-provider v-slot="{ errors }" rules="required">
        <custom-input
          v-model="goal.description"
          custom-error-msg="Favor escribir una descripción de la meta."
          :error="errors[0]"
          label="Introducir Meta:"
          maxlength="500"
          type="text"
        />
      </validation-provider>
    </div>
    <div class="col-12 mt-2 d-flex justify-content-end">
      <action-button
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3"
        @click="cancel"
      />

      <action-button
        i="fa fa-save"
        text="Añadir"
        variant="success"
        @click="saveGoal"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';

export default {
  name: 'GoalForm',
  components: {
    CustomInput,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => null,
    },
  },
  data: () => ({
    goal: {
      description: null,
      objectives: [],
    },
    isEditing: false,
  }),
  watch: {
    data: {
      immediate: true,
      handler(current) {
        if (current) {
          this.goal = current;
          this.isEditing = true;
        }
      },
    },
  },
  methods: {
    saveGoal() {
      const event = this.isEditing ? 'edit-goal' : 'save-goal';
      this.$emit(event, this.goal);
    },
    cancel() {
      const event = !this.isEditing ? 'cancel-add' : 'cancel-update';
      this.$emit(event);
    },
  },
};
</script>
